import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';

import { CalloutInline } from '@modernhealth/vital-components';

const Container = styled.div({
    marginBottom: '30px',
});

const ContactBox = styled.div({
    marginTop: '10px',
});

export const InvalidInsuranceErrorBox = () => {
    const { t } = useTranslation();

    return (
        <Container data-testid="InvalidInsuranceErrorBox">
            <CalloutInline variant="danger">
                <div>{t('insuranceForm:insurance_invalid.box.description')}</div>
                <ContactBox>{t('insuranceForm:insurance_invalid.box.contact')}</ContactBox>
            </CalloutInline>
        </Container>
    );
};
